<ng-container *ngIf="!isLogoLoading">
  <div *ngIf="!isSecondLogo || IframeMode" class="header-logo-wrap__container"
    [ngClass]="{'header-logo-wrap__container-wide': isWideLogo }">
    <a *unlessBrandingAttr="'logo_custom_url'"
      [routerLink]="['/']">
      <div class="header-logo-wrap" [style.background-image]="'url(' + getLogoUrl + ')'"></div>
    </a>

    <a *brandingAttr="'logo_custom_url'"
       [href]="'logo_custom_url' | displayBrandingAttr:'profile_attributes'"
       target="_blank">
      <div class="header-logo-wrap" [style.background-image]="'url(' + getLogoUrl + ')'"></div>
    </a>
  </div>

  <div *ngIf="isSecondLogo && !IframeMode" class="header-dual-container">
    <a [routerLink]="['/']" fxLayoutAlign="row center">
      <!--
        FE-200 — SOURCE ORDER IS THE LAYOUT NOW, so the plus sits between the two
        logos rather than ahead of them.

        It used to be first here and that was fine: the old lockup made `.header-
        dual` a 25px anchor holding just the glyph, with both logos absolutely
        positioned outside it at left/right: -230px, and absolute placement
        ignores source order. The reskin rebuilt the lockup as a real flex row
        (`app-cobrand-lockup` in assets/styles/components/header-logo/
        header-logo.scss sets `position: static` on all three) because the 25px
        anchor reserved 25px of layout for ~475px of painted content. Once they
        are static, the DOM decides — and the plus was still first, so it
        rendered to the left of the starting logo.

        Fixed by moving the element rather than with `order`, so what a reader
        sees in the template is what the header paints.
      -->
      <div class="header-dual">
        <div class="header-dual-first">
          <img [src]="getLogoUrl" alt="plus" [ngClass]="{ 'header-dual-first-square': isSquareLogo }">
        </div>
        <img class="header-dual-plus" src="./assets/logos/header_logo_plus.png" alt="plus">
        <div class="header-dual-second">
          <img [src]="headerSecondLogoUrl" alt="plus" [ngClass]="{ 'header-dual-second-square': isSquareSecondLogo }">
        </div>
      </div>
    </a>
  </div>
</ng-container>
